<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class ExtraServicePageMixin extends Vue {
        async loadRuntimeData() {
            if (extraServicesRuntimeStore.city.id !== this.searchRequest.cityId) {
                await extraServicesRuntimeStore.loadCity(this.searchRequest.cityId)
            }
        }
    }

    export default ExtraServicePageMixin
</script>
